var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerbiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 27.5 1 C 26.122 1 25 2.122 25 3.5 L 25 10 L 31.5 10 C 33.981 10 36 12.019 36 14.5 L 36 49 L 40.5 49 C 41.878 49 43 47.879 43 46.5 L 43 3.5 C 43 2.122 41.878 1 40.5 1 L 27.5 1 z M 18.5 12 C 17.122 12 16 13.122 16 14.5 L 16 20 L 22.5 20 C 24.981 20 27 22.019 27 24.5 L 27 49 L 31.5 49 C 32.878 49 34 47.879 34 46.5 L 34 14.5 C 34 13.122 32.878 12 31.5 12 L 18.5 12 z M 9.5 22 C 8.122 22 7 23.122 7 24.5 L 7 46.5 C 7 47.879 8.122 49 9.5 49 L 22.5 49 C 23.878 49 25 47.879 25 46.5 L 25 24.5 C 25 23.122 23.878 22 22.5 22 L 9.5 22 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbiWhite);
export default __webpack_public_path__ + "static/media/powerbi-white.1764215da601f10c919ed5ca6efa4852.svg";
export { ForwardRef as ReactComponent };